function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.571 1.143H24.43M1.57 8H21.55M1.571 14.857H18.67",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
});

var SvgHamburgerIcon = function SvgHamburgerIcon(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 16"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI2IDE2Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEpIj4KICAgIDxwYXRoIGQ9Ik0uNTcxNDI4NTcxIDEuMTQyODU3MTRMMjMuNDI4NTcxNCAxLjE0Mjg1NzE0TS41NzE0Mjg1NzEgOEwyMC41NDkwMjgxIDhNLjU3MTQyODU3MSAxNC44NTcxNDI5TDE3LjY2OTAyODEgMTQuODU3MTQyOSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgHamburgerIcon as ReactComponent };